import remainingChars from "surveylabJsAssets/page/_remaining-chars";

export default function () {
    remainingChars.initOnce();
}